import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const ArticlePreview = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* ARTICLE PREVIEWS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Article Previews</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Text Only Article</label>
            <article className="space-y-2">
              <h3 className="text-sm font-bold text-slate-200">Article Title</h3>
              <p className="text-xs text-slate-500">Published 2 hours ago</p>
              <p className="text-xs text-slate-400 line-clamp-2">Brief summary of the article content goes here. This would typically be truncated to show just the first couple lines...</p>
              <a href="#" className="text-xs text-amber-400 hover:text-amber-300">Read more </a>
            </article>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<article className="space-y-2">
  <h3 className="text-sm font-bold">Title</h3>
  <p className="text-xs text-slate-500">Published time</p>
  <p className="text-xs line-clamp-2">Summary...</p>
  <a href="#" className="text-amber-400">Read more </a>
</article>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Image</label>
            <article className="flex gap-3 p-2 bg-slate-950 rounded border border-slate-600">
              <div className="w-20 h-20 bg-slate-700 rounded flex-shrink-0"></div>
              <div className="flex-1 min-w-0">
                <h3 className="text-xs font-bold text-slate-200 line-clamp-1">Article Title Text</h3>
                <p className="text-xs text-slate-500 mt-1">Category  3 min read</p>
                <p className="text-xs text-slate-400 mt-1 line-clamp-1">Brief preview of content...</p>
              </div>
            </article>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<article className="flex gap-3">
  <img className="w-20 h-20" />
  <div>
    <h3 className="text-xs font-bold">Title</h3>
    <p className="text-xs text-slate-500">Category</p>
  </div>
</article>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Card Style</label>
            <article className="p-3 bg-slate-950 rounded border border-slate-600 space-y-2">
              <div className="w-full h-20 bg-slate-700 rounded mb-2"></div>
              <h3 className="text-sm font-bold text-slate-200">Featured Article</h3>
              <p className="text-xs text-slate-500">By Author  March 15, 2024</p>
              <p className="text-xs text-slate-400 line-clamp-2">The content summary appears here with truncation...</p>
              <div className="flex justify-between items-center pt-2">
                <span className="text-xs text-slate-600">5 min read</span>
                <button className="text-xs text-amber-400 hover:text-amber-300">Read </button>
              </div>
            </article>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<article className="p-3 bg-slate-950 rounded">
  <div className="w-full h-20 rounded"></div>
  <h3 className="font-bold">Title</h3>
  <p className="text-xs text-slate-500">By Author</p>
  <p className="text-xs line-clamp-2">Summary</p>
</article>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">List Format</label>
            <div className="space-y-2">
              {["First Article", "Second Story", "Third Post"].map(title => (
                <div key={title} className="p-2 border-b border-slate-700 last:border-0">
                  <p className="text-xs text-slate-300 font-medium">{title}</p>
                  <p className="text-xs text-slate-500 mt-0.5">2 minutes read</p>
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-2">
  {articles.map(a => (
    <div className="p-2 border-b">
      <p className="text-xs font-medium">{a.title}</p>
      <p className="text-xs text-slate-500">{a.time}</p>
    </div>
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Tags</label>
            <article className="p-3 bg-slate-950 rounded border border-slate-600">
              <h3 className="text-sm font-bold text-slate-200 mb-1">Article Title Here</h3>
              <div className="flex gap-1 mb-2 flex-wrap">
                <span className="text-xs px-1.5 py-0.5 bg-slate-800 text-slate-400 rounded">Technology</span>
                <span className="text-xs px-1.5 py-0.5 bg-slate-800 text-slate-400 rounded">News</span>
              </div>
              <p className="text-xs text-slate-400 line-clamp-1">Article summary here...</p>
            </article>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<article className="p-3 bg-slate-950 rounded">
  <h3 className="font-bold mb-1">Title</h3>
  <div className="flex gap-1 mb-2">
    <span className="text-xs px-1.5 py-0.5 bg-slate-800">Tag</span>
  </div>
  <p className="text-xs">Summary</p>
</article>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Grid Layout</label>
            <div className="grid grid-cols-2 gap-2">
              {[1, 2].map(i => (
                <article key={i} className="text-center">
                  <div className="bg-slate-800 h-16 rounded mb-1"></div>
                  <p className="text-xs text-slate-300 font-medium line-clamp-1">Post Title</p>
                  <p className="text-xs text-slate-500">1 min ago</p>
                </article>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="grid grid-cols-2 gap-2">
  {posts.map(p => (
    <article className="text-center">
      <div className="h-16 rounded mb-1"></div>
      <p className="text-xs">{p.title}</p>
    </article>
  ))}
</div>`} />
          </div>
        </div>
      </div>

      {/* FEATURED ARTICLES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Featured Articles</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Hero Article</label>
            <article className="p-4 gradient-to-br from-slate-800 to-slate-900 rounded-lg border border-slate-600">
              <span className="text-xs bg-amber-900 text-amber-300 px-2 py-1 rounded-full">FEATURED</span>
              <h2 className="text-lg font-bold text-slate-100 mt-2 mb-2">Featured Article Title</h2>
              <p className="text-xs text-slate-400 mb-3">Complete description of the featured content starts here...</p>
              <button className="px-3 py-1.5 bg-amber-600 text-white text-xs rounded hover:bg-amber-700">Read Full Article</button>
            </article>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<article className="p-4 rounded-lg border">
  <span className="bg-amber-900 px-2 py-1 rounded-full">FEATURED</span>
  <h2 className="text-lg font-bold mt-2">Title</h2>
  <p className="text-xs mb-3">Description</p>
  <button className="px-3 py-1.5 bg-amber-600">Read</button>
</article>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticlePreview;


